(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["filter-press-bundle"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const addToCartButtons = document.querySelectorAll('.add-to-cart-bundle');
    
    async function addToCart(variantId, buttonElement) {
      // Show loading state
      const originalText = buttonElement.textContent;
      buttonElement.classList.add('loading');
      buttonElement.textContent = 'Adding...';
      
      const feedbackElement = buttonElement.closest('.bundle-up').querySelector('.cart-feedback-message');
      
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1
          })
        });
        
        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.description || 'Failed to add item to cart');
        }
        
        const data = await response.json();
        
        // Success feedback
        buttonElement.classList.add('added');
        buttonElement.textContent = 'Added! ✓';
        
        if (feedbackElement) {
          feedbackElement.textContent = 'Bundle added to cart!';
          feedbackElement.style.display = 'block';
          feedbackElement.classList.add('success');
          setTimeout(() => {
            feedbackElement.style.display = 'none';
            feedbackElement.classList.remove('success');
          }, 3000);
        }
        
        // Trigger cart update event for themes that support it
        if (typeof window.dispatchEvent === 'function') {
          window.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: data } }));
        }
        
        // Optional: Update cart count if a cart counter exists
        const cartCountElement = document.querySelector('.cart-count, .cart__count, [data-cart-count]');
        if (cartCountElement) {
          const cartResponse = await fetch('/cart.js');
          const cartData = await cartResponse.json();
          const itemCount = cartData.item_count;
          if (cartCountElement) {
            cartCountElement.textContent = itemCount;
            if (cartCountElement.classList.contains('cart-count')) {
              cartCountElement.textContent = itemCount;
            }
          }
        }
        
        // Reset button after delay
        setTimeout(() => {
          buttonElement.classList.remove('added', 'loading');
          buttonElement.textContent = originalText;
        }, 2000);
        
      } catch (error) {
        console.error('Add to cart error:', error);
        
        buttonElement.classList.remove('loading');
        buttonElement.textContent = originalText;
        
        if (feedbackElement) {
          feedbackElement.textContent = error.message || 'Error adding to cart. Please try again.';
          feedbackElement.style.display = 'block';
          feedbackElement.classList.add('error');
          setTimeout(() => {
            feedbackElement.style.display = 'none';
            feedbackElement.classList.remove('error');
          }, 4000);
        }
      }
    }
    
    addToCartButtons.forEach(button => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        const variantId = this.getAttribute('data-variant-id');
        if (!variantId) {
          console.error('No variant ID found');
          const feedbackElement = this.closest('.bundle-up').querySelector('.cart-feedback-message');
          if (feedbackElement) {
            feedbackElement.textContent = 'Product configuration error.';
            feedbackElement.style.display = 'block';
            feedbackElement.classList.add('error');
            setTimeout(() => {
              feedbackElement.style.display = 'none';
              feedbackElement.classList.remove('error');
            }, 3000);
          }
          return;
        }
        
        // Prevent multiple rapid clicks
        if (this.classList.contains('loading')) return;
        
        addToCart(variantId, this);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
/* ══════════════════════════════════════════════
   STICKY HEADER
══════════════════════════════════════════════ */
class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('.header-wrapper');
    this.headerBounds = {};
    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });
    observer.observe(this.header);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('shopify-section-header-sticky');
      requestAnimationFrame(() => {
        this.header.classList.remove('is-visible');
        document.body.classList.remove('header-is-visible'); // ← added
      });
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      if (!this.preventReveal) {
        this.header.classList.add('shopify-section-header-sticky');
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            this.header.classList.add('is-visible');
            document.body.classList.add('header-is-visible'); // ← added
          });
        });
      }
      this.preventReveal = false;
    } else if (scrollTop <= this.headerBounds.top) {
      this.header.classList.remove('shopify-section-header-sticky', 'is-visible');
      document.body.classList.remove('header-is-visible'); // ← added
    }

    this.currentScrollTop = scrollTop;
  }
}

customElements.define('sticky-header', StickyHeader);



/* ══════════════════════════════════════════════
   MENU DRAWER OVERLAY + BODY LOCK
   Handles: overlay show/hide, body scroll lock,
   overflow-hidden-tablet sync, close button,
   overlay click, swipe-left gesture
══════════════════════════════════════════════ */
(function() {
  const overlay      = document.getElementById('menu-overlay');
  const drawerDetails = document.getElementById('Details-menu-drawer-container');
  if (!overlay || !drawerDetails) return;

  /* ── Centralised open state ── */
  function openDrawer() {
    // Show overlay
    overlay.style.display = 'block';
    requestAnimationFrame(() => {
      requestAnimationFrame(() => overlay.classList.add('is-active'));
    });

    // Lock body scroll — both inline style AND Dawn's tablet class
    document.body.style.overflow = 'hidden';
    document.body.classList.add('overflow-hidden-tablet');
  }

  function closeDrawer() {
    // Fade overlay out, then hide
    overlay.classList.remove('is-active');
    overlay.addEventListener('transitionend', function handler() {
      if (!overlay.classList.contains('is-active')) overlay.style.display = 'none';
      overlay.removeEventListener('transitionend', handler);
    });

    // Unlock body scroll — remove BOTH the inline style AND Dawn's class
    document.body.style.overflow = '';
    document.body.classList.remove('overflow-hidden-tablet');
  }

  /* ── Watch the <details> attribute so we stay in sync with
        Dawn's own open/close (hamburger click, escape key, etc.) ── */
  new MutationObserver(() => {
    if (drawerDetails.hasAttribute('open')) {
      openDrawer();
    } else {
      closeDrawer();
    }
  }).observe(drawerDetails, { attributes: true, attributeFilter: ['open'] });

  /* ── Helper: fully close the drawer via Dawn's summary click
        so Dawn's own JS (focus-trap, aria, etc.) also fires ── */
  function triggerDawnClose() {
    if (drawerDetails.hasAttribute('open')) {
      const summary = drawerDetails.querySelector('summary');
      if (summary) {
        summary.click();   // Dawn removes [open] → MutationObserver fires → closeDrawer()
      } else {
        drawerDetails.removeAttribute('open');
        closeDrawer();
      }
    }
  }

  /* ── Overlay click → close ── */
  overlay.addEventListener('click', triggerDawnClose);

  /* ── Custom close button (✕ next to search) → close ── */
  document.querySelectorAll('.menu-drawer-close__button').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      triggerDawnClose();
    });
  });

  /* ── Swipe left on drawer → close ── */
  let touchStartX = 0;
  const drawer = document.getElementById('menu-drawer');
  if (drawer) {
    drawer.addEventListener('touchstart', (e) => {
      touchStartX = e.touches[0].clientX;
    }, { passive: true });

    drawer.addEventListener('touchend', (e) => {
      if (e.changedTouches[0].clientX - touchStartX < -60) triggerDawnClose();
    }, { passive: true });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multi-packs"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  /* ── Toast ── */
  var toast      = document.getElementById('pack-toast');
  var toastTimer = null;

  function showToast(msg, type) {
    if (!toast) return;
    clearTimeout(toastTimer);
    toast.textContent = msg;
    toast.className   = 'pack__toast pack__toast--show pack__toast--' + (type || 'success');
    toastTimer = setTimeout(function () { toast.className = 'pack__toast'; }, 3000);
  }

  /* ── Button state helpers ── */
  function setButtonState(btn, state, labelText) {
    btn.dataset.state = state;
    var label = btn.querySelector('.pack__atc-label');
    if (label && labelText !== undefined) label.textContent = labelText;
  }

  function resetButton(btn, originalLabel) {
    setTimeout(function () {
      btn.removeAttribute('data-state');
      var label = btn.querySelector('.pack__atc-label');
      if (label) label.textContent = originalLabel;
    }, 2200);
  }

  /* ── Price row DOM update ── */
  function updatePriceRow(row, price, was, save) {
    var priceEl = row.querySelector('.pack__price-now');
    var wasEl   = row.querySelector('.pack__price-was');
    var saveEl  = row.querySelector('.pack__save');
    if (priceEl) priceEl.textContent = price || '';
    if (wasEl)  { wasEl.textContent = was || ''; wasEl.style.display = was ? '' : 'none'; }
    if (saveEl) { saveEl.textContent = save || ''; saveEl.style.display = save ? '' : 'none'; }
  }

  /* ── Purchase toggle ── */
  document.querySelectorAll('[data-toggle-type]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var blockId  = btn.dataset.blockId;
      var type     = btn.dataset.toggleType;
      var toggle   = document.querySelector('[data-purchase-toggle="' + blockId + '"]');
      var priceRow = document.querySelector('[data-price-row="' + blockId + '"]');
      var spInfo   = document.querySelector('[data-sp-info="' + blockId + '"]');
      var atcBtn   = document.querySelector('[data-atc-btn][data-block-id="' + blockId + '"]');

      if (toggle) {
        toggle.querySelectorAll('.pack__toggle-btn').forEach(function (b) {
          b.classList.toggle('pack__toggle-btn--active', b.dataset.toggleType === type);
        });
      }

      if (type === 'subscribe') {
        if (spInfo) { spInfo.style.display = ''; spInfo.removeAttribute('aria-hidden'); }
        if (priceRow) {
          updatePriceRow(priceRow, priceRow.dataset.spPrice, priceRow.dataset.spWas, priceRow.dataset.spSave);
          var pe = priceRow.querySelector('.pack__price-now');
          if (pe) pe.classList.add('pack__price-now--sub');
        }
        if (atcBtn) {
          atcBtn.dataset.sellingPlanId = atcBtn.dataset.spId || '';
          atcBtn.classList.add('pack__atc--subscribe');
        }
      } else {
        if (spInfo) { spInfo.style.display = 'none'; spInfo.setAttribute('aria-hidden', 'true'); }
        if (priceRow) {
          updatePriceRow(priceRow, priceRow.dataset.onetimePrice, priceRow.dataset.onetimeWas, priceRow.dataset.onetimeSave);
          var pe = priceRow.querySelector('.pack__price-now');
          if (pe) pe.classList.remove('pack__price-now--sub');
        }
        if (atcBtn) {
          atcBtn.dataset.sellingPlanId = '';
          atcBtn.classList.remove('pack__atc--subscribe');
        }
      }
    });
  });

  /* ── AJAX Add to Cart ── */
  document.querySelectorAll('[data-atc-btn]').forEach(function (btn) {
    var variantId     = btn.dataset.variantId;
    var originalLabel = (btn.querySelector('.pack__atc-label') || btn).textContent.trim();

    if (!variantId) return;

    btn.addEventListener('click', function () {
      if (btn.dataset.state === 'loading') return;

      var sellingPlanId = (btn.dataset.sellingPlanId || '').trim();
      var payload       = { id: parseInt(variantId, 10), quantity: 1 };
      if (sellingPlanId) payload.selling_plan = parseInt(sellingPlanId, 10);

      setButtonState(btn, 'loading', '');

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body:    JSON.stringify({ items: [payload] })
      })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (e) { throw e; });
        return res.json();
      })
      .then(function () {
        var isSub = !!sellingPlanId;
        setButtonState(btn, 'success', isSub ? '✓ Subscribed!' : '✓ Added!');
        showToast(isSub ? 'Subscription added to cart!' : 'Added to cart!', 'success');
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        fetch(window.Shopify.routes.root + 'cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            document.querySelectorAll('[data-cart-count], .cart-count, #CartCount')
              .forEach(function (el) { el.textContent = cart.item_count; });
          })
          .catch(function () {});
        resetButton(btn, originalLabel);
      })
      .catch(function (err) {
        var msg = (err && err.description) ? err.description : 'Could not add to cart.';
        setButtonState(btn, 'error', 'Error');
        showToast(msg, 'error');
        resetButton(btn, originalLabel);
      });
    });
  });

  /* ── ADDED: Mobile slider arrows + dot indicators ── */
  document.querySelectorAll('.packs__slider-wrapper').forEach(function (wrapper) {
    var scroll   = wrapper.querySelector('.packs__scroll');
    var prevBtn  = wrapper.querySelector('.packs__arrow--prev');
    var nextBtn  = wrapper.querySelector('.packs__arrow--next');

    /* Dots live outside the wrapper — find the nearest sibling */
    var dotsContainer = wrapper.parentElement
      ? wrapper.parentElement.querySelector('.packs__dots')
      : null;
    var dots = dotsContainer ? dotsContainer.querySelectorAll('.packs__dot') : [];

    if (!scroll) return;

    /* How far to scroll per arrow tap (one card width + gap) */
    function getScrollStep() {
      var firstCard = scroll.querySelector('.pack');
      return firstCard ? firstCard.offsetWidth + 12 : 252;
    }

    /* Update arrow disabled state + active dot */
    function updateControls() {
      /* Only applies on mobile (arrows are display:none on desktop) */
      if (prevBtn) prevBtn.disabled = scroll.scrollLeft <= 4;
      if (nextBtn) nextBtn.disabled = scroll.scrollLeft >= scroll.scrollWidth - scroll.clientWidth - 4;

      /* Active dot = which card is most visible */
      if (dots.length) {
        var cards     = scroll.querySelectorAll('.pack');
        var centerX   = scroll.scrollLeft + scroll.clientWidth / 2;
        var closest   = 0;
        var closestDelta = Infinity;
        cards.forEach(function (card, i) {
          var cardCenter = card.offsetLeft + card.offsetWidth / 2;
          var delta      = Math.abs(cardCenter - centerX);
          if (delta < closestDelta) { closestDelta = delta; closest = i; }
        });
        dots.forEach(function (dot, i) {
          dot.classList.toggle('packs__dot--active', i === closest);
        });
      }
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        scroll.scrollBy({ left: -getScrollStep(), behavior: 'smooth' });
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        scroll.scrollBy({ left: getScrollStep(), behavior: 'smooth' });
      });
    }

    scroll.addEventListener('scroll', updateControls, { passive: true });

    /* Initial state */
    updateControls();
  });
  /* ── END mobile slider ── */

})();

  } catch(e) { console.error(e); }
})();
})();
